import { render, staticRenderFns } from "./showTitle.vue?vue&type=template&id=74574531&"
var script = {}
import style0 from "./showTitle.vue?vue&type=style&index=0&id=74574531&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports